import { useState } from "react"

export const InsurableInterest = () => {

    const [ReadMoreText, setReadMoreText] = useState(false)
    const [ReadMoreFacts, setReadMoreFacts] = useState(false)

    const handleReadmore = () => {
        setReadMoreText(!ReadMoreText)
    }

    const handleReadmoreFacts = () => {
        setReadMoreFacts(!ReadMoreFacts)
    }

    return (
        <>
         <div className="container-fluid">
            <div className="row pb-lg-5">

                <div className="col-lg-12 text-center pb-5">
                    <h2 className=" mt-4 fw-bold green">Insurable Interest </h2>
                    <div className="col-8 col-lg-3 mx-auto zoom-in-out-box2 ">
                        <hr />
                    </div>
                </div>

                <div className="col-12 px-lg-5 pb-5">
                    <div className="p-4" style={{ position: 'relative', textAlign: 'justify' }}>
                        <p>
                            Person may be at loss by destruction of the subject matter only when he has some relationship, legal or equitable with the subject matter insured so that he may be benefitted by the safety of it or incur the loss or liability in case of loss or damage to it.
                        </p>

                        <h5 className="green"><b>In Marine Insurance, Who is having Insurable Interest? </b> </h5>
                        <p>
                            “Every person has an insurable interest who is interested in a marine adventure.”
                        </p>
                        <p>
                            Hence in the Marine adventure, several persons may be so connected with the subject matter of insurance as each one of them may have several and distinct insurable interest therein. To give an example the following categories of persons may have insurable interest in the Ship-
                        </p>

                        <ul className="ps-5">
                            <li>Owner of the ship.</li>
                            <li>Bare Boat charter of the ship.</li>
                            <li>Mortgagee of the ship.</li>
                            <li>The underwriter (In respect of reinsurance they have arranged for the risk)
                            </li>
                        </ul>

                        {ReadMoreText && (
                            <div>

                                <p>
                                    Insurable Interest is defined in the section 5 of the Marine Insurance Act 1906. If the assured do not have insurable interest in the subject matter of insurance the said contract of Marine insurance is deemed to be a gaming or wagering contract and every contract of marine insurance by way of gaming or wagering is a void contract as per Section 4 of the Act.
                                </p>
                                <p>
                                    Policies which forego the proof of insurable interest and states that the policy itself will be taken as sufficient proof of insurable interest in the event of the claim are known as Policy <b> Proof of interest (PPI) or honour policies.</b>
                                    Such policies are arranged merely for the commercial convenience. Such policies are arranged for Shipowner’s Disbursements, Increased Value of Cargo.
                                </p>
                            </div>

                        )}

                        <p className="float-end read_more_btn pb-lg-3 ">
                            <button className="btn button" onClick={handleReadmore}>
                                <span>{ReadMoreText ? 'Read Less' : 'Read More'}</span>
                            </button>
                        </p>


                    </div>

                </div>
                <div className="col-12 px-lg-5" >
                    <div className="p-lg-5 p-1 bgservices " style={{ position: 'relative', textAlign: 'justify', }}>
                        <h5 className="fw-bold pb-3">Case Law: </h5>
                        <p> The principle of Insurable Interest is largely founded on the Judgement of Lawrence J in the <b> Lucena v. Crauford  </b> (1806).
                        </p>
                        <p>“To be interested…is to be so circumstanced with respect to it as to have benefit from its existence, prejudice from its destruction.”</p>
                        <p><b>Facts of the case:</b></p>
                        <p>The assured was the Commissioners of Admiralty, whose duty was, under statute, to take care of Dutch vessels and cargoes ‘which had been or might be thereafter detained in or brought into the ports of the United Kingdom ‘.
                            Before the commission was issued, certain Dutch vessels and their cargoes had been seized by order the British Government for the purpose of being bought to England.</p>
                        {ReadMoreFacts &&
                            <>
                                <p> After the commission was issued, the Commissioners insured these ships and their cargoes. The Ships were lost during their voyage to England.
                                    The Commissioners then sought to recover under the policy. The Insurer’s defence was that the Commissioners had no insurable interest in the ships at the time of loss.</p>
                                <p> The House of Lords upheld the insurer’s defence on the basis that the Commissioners’ duty was to take care of the ships only after their arrival. Since the ships had not yet arrived in England at the time of loss, the Commissioners did not have an insurable interest.
                                </p>
                            </>
                        }

                        <p className="float-end read_more_btn pb-lg-3 ">
                            <button className="btn button" onClick={handleReadmoreFacts}>
                                <span>{ReadMoreFacts ? 'Read Less' : 'Read More'}</span>
                            </button>
                        </p>
                    </div>
                </div>

                <div className="col-12 px-lg-5 mt-5 ">
                    <div className=" food_for_health p-4 p-lg-0">

                        <div className="row ps-lg-5">
                            <div className="col-12 col-lg-8  pt-lg-5" style={{ textAlign: 'justify' }}>
                                <p><b> Food for Thought:  </b></p>

                                <p>Judgements in the Case Laws over the period has also expanded the definition of the Insurable Interest.</p>
                                <p> <i class="fa-solid fa-circle-question text-danger pe-3"></i>
                                    What are the types of Insurable Interest?
                                </p>
                                <p> <i class="fa-solid fa-circle-question text-danger pe-3"></i>
                                    When the Insurable Interest must attached for Marine policies?
                                </p>
                            </div>
                            <div className="col-12 col-lg-4 d-flex align-items-center justify-content-center">
                                <img src="Static/Assets/Img/questionary.png" className="questionery_img mx-auto" alt="" srcset="" />
                            </div>
                        </div>

                    </div>
                </div>



            </div>
</div>
        </>
    )
}
